import { TableColumnType } from 'src/types/table';
import { allColumns } from './constants';

export const getColumns = (key: string): TableColumnType[] => {
    switch (key) {
        case 'serviceCodes':
            return allColumns.filter((column) =>
                ['rawLabel', 'value', 'shipperCode', 'isExpedition', 'isReturn', 'countryCodesSelect'].includes(
                    column.key
                )
            );
        case 'claimStatusCodes':
        case 'transportStatusCodes':
        case 'returnStatusCodes':
            return allColumns.filter((column) => ['rawLabel', 'value', 'color'].includes(column.key));
        case 'orderStatusCodes':
            return allColumns.filter((column) =>
                ['rawLabel', 'value', 'color', 'editOrder', 'ORDER_INT'].includes(column.key)
            );
        case 'receivingStatusCodes':
            return allColumns.filter((column) => ['rawLabel', 'value', 'awaiting'].includes(column.key));
        case 'shipperMessageCodes':
            return allColumns.filter((column) => ['rawLabel', 'value', 'shipperCode', 'LANG'].includes(column.key));
        default:
            return allColumns.filter((column) => ['rawLabel', 'value'].includes(column.key));
    }
};
